import * as React from 'react';
import { Link } from "gatsby";
import { BreadcrumbsContext } from "../../../context/BreadcrumbsContext";
import "./breadcrumb.css";

/**
 * Sayfa yolu: "Ana sayfa › Trendyol › Ürün adı". Sayfalar BreadcrumbsContext'e [{ path, name }] yazar; son öğe bulunulan
 * sayfadır (bağlantı değil, kısaltılır). Eskisi MUI Breadcrumbs + ev simgesiydi, mobilde iki satıra taşıyordu.
 */
export default function GenericBreadcrumbs() {
    const { breadcrumbdata } = React.useContext(BreadcrumbsContext);
    if (!breadcrumbdata || breadcrumbdata.length === 0) {
        return null;
    }
    const son = breadcrumbdata.length - 1;
    return (
        <nav className="iu-yol" aria-label="Sayfa yolu">
            <ol>
                {breadcrumbdata.map((dt, i) => (
                    <li key={i} className={i === son ? "iu-yol-son" : undefined}>
                        {i === son
                            ? <span aria-current="page" title={dt.name}>{dt.name}</span>
                            : <Link to={dt.path}>{dt.name}</Link>}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
